
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.7 10l7.65 7.65-.7.7L10 10.7l-7.65 7.65-.7-.7L9.3 10 1.65 2.35l.7-.7L10 9.3l7.65-7.65.7.7L10.7 10z"}})])
          )
        }
      }
    